import styled from "@emotion/styled"

export const StyledFloatingWrapper = styled.div`
  position: fixed;
  right: 1rem;
  bottom: 9rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 10000;

  ${props => props.theme.breakpoints.up("sm")} {
    bottom: 2rem;
  }
`
